const PRODUCT_CONSTANT = '/p/'
/**
 * Given a product and the current locale returns an href to the product detail page.
 *
 * @param {Object} product
 * @returns {string}
 */
export const productUrlBuilder = (product) => {
    // Slug URLs from custom fields should already be properly formatted/encoded
    // Return as-is to avoid double-encoding (e.g., %3A becoming %253A)
    if (product?.c_variationGroup_slugUrl) {
        return product.c_variationGroup_slugUrl
    }
    if (product?.c_slugUrl) {
        return product.c_slugUrl
    }
    return productUrlBuilderFromSlug(product) // TODO: Remove wheh this the custom slug field will be present in all the apis
}

export const productUrlBuilderFromSlug = (product) => {
    const slug = product?.slugUrl?.split(PRODUCT_CONSTANT)?.[1]
    if (slug) {
        const url = PRODUCT_CONSTANT + slug
        return encodeURI(url)
    }
    return PRODUCT_CONSTANT + product?.productId + '.html'
}

export * from '@salesforce/retail-react-app/app/utils/url'
